<template>
  <svg width="14"
       height="17"
       viewBox="0 0 14 17"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0.313477C6.41992 0.313477 6.01562 0.717773 6.01562 1.29785V12.1523L6.09473 14.0596L3.80957 11.5107L1.81445 9.52441C1.63867 9.34863 1.39258 9.23438 1.11133 9.23438C0.575195 9.23438 0.179688 9.63867 0.179688 10.1924C0.179688 10.4473 0.276367 10.6846 0.487305 10.8955L6.27051 16.6963C6.46387 16.8984 6.72754 17.0039 7 17.0039C7.26367 17.0039 7.52734 16.8984 7.7207 16.6963L13.5127 10.8955C13.7236 10.6846 13.8203 10.4473 13.8203 10.1924C13.8203 9.63867 13.416 9.23438 12.8799 9.23438C12.6074 9.23438 12.3613 9.34863 12.1855 9.52441L10.1816 11.5107L7.90527 14.0508L7.97559 12.1523V1.29785C7.97559 0.717773 7.57129 0.313477 7 0.313477Z"
          :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'ArrowDownIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
